import { define, type, auto, Record, Collection } from 'type-r'

import Phone from '#metatypes/phone.js'
import ValidRecord from './valid_record';

@define 
export class ContactCollection<R extends Contact = Contact> extends Collection<R> { }
@define 
export class Contact extends ValidRecord {
    static Collection = ContactCollection<Contact>;
    
    @auto name: string
    @auto relation: string
    @(type(Phone).as) phone: string
}
